import React, { useState } from "react";
import GetMonths from "../../Dropdowns/getMonths";
import GetYears from "../../Dropdowns/getYears";
import GetDistricts from "../../Dropdowns/getAllDistricts";
import GetAfsoo from "../../Dropdowns/getAfsoAll";
import ShopWiseCardandSaleDetailsTable from "./ShopWiseCardandSaleDetailsTable";

function ShopWiseCardandSaleDetails({ heading }) {
    const [renderContent, setRenderContent] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingDistricts, setLoadingDistricts] = useState(false);
    const [loadingAfso, setLoadingAfso] = useState(false);
    const [statusType, setStatusType] = useState("");
    const [statusValue, setStatusValue] = useState("");

    const [selectedDist, setSelectedDist] = useState("");
    const [selectedAfso, setSelectedAfso] = useState("");

    const handleDistrictChange = (dist_code) => {
        setSelectedDist(dist_code);
        setSelectedAfso(""); // reset AFSO when district changes
    };

    const handleAfsoChange = (afso_code) => {
        setSelectedAfso(afso_code);
    };

    const handleLoadingChange = (isLoading) => {
        setLoading(isLoading);
    };

    const handleSubmit = () => {
        const month = document.getElementById("month")?.value;
        const year = document.getElementById("year")?.value;
        const dist_code = document.getElementById("dist_code")?.value;
        let status = document.getElementById("statusType").value;

        if (!status) {
            alert("Please select Distribution Status");
            return;
        }
        status = Number(status);

        let afso_code = "0";
        if (dist_code !== "0" && dist_code.toLowerCase() !== "all") {
            afso_code = document.getElementById("afso_code")?.value;
        }

        if (!month || month === "0") {
            alert("Please select Month");
            return;
        }

        if (!year || year === "0") {
            alert("Please select Year");
            return;
        }

        if (!dist_code) {
            alert("Please select District");
            return;
        }

        if (dist_code !== "0" && dist_code.toLowerCase() !== "all") {
            if (!afso_code ) {
                alert("Please select AFSO");
                return;
            }
        }
        if (!status || status === "0") {
            alert("Please select Distribution Percentage");
            return;
        }
                if (!statusValue ) {
            alert("Please Enter Distribution Percentage");
            return;
        }

        setRenderContent(null);

        setTimeout(() => {
            setRenderContent(
                <>
                    <ShopWiseCardandSaleDetailsTable
                        month={month}
                        year={year}
                        afso_code={afso_code}
                        dist_code={dist_code}
                        status={status}
                        heading={heading}
                        statusValue={statusValue}
                    />
                </>
            );
        }, 0);
    };

    const handleStatusValueChange = (e) => {
    let value = e.target.value;
    
    // Allow only empty string or digits 0-9
    if (value === '') {
      setStatusValue('');
      return;
    }
    
    // Remove any non-digit characters
    value = value.replace(/[^\d]/g, '');
    
    // If empty after sanitization, don't update
    if (value === '') {
      return;
    }
    
    // Parse and validate range 0-100
    const num = parseInt(value, 10);
    if (num >= 0 && num <= 100) {
      setStatusValue(String(num));
    }
  };

    return (
        <div className="wrapper row3">
            <div id="container">
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <table width="60%">
                        <thead>
                            <tr className="tableheader">
                                <th colSpan={12}>{heading}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Month</td>
                                <td>
                                    <GetMonths id="month" onLoadingChange={handleLoadingChange} />
                                </td>

                                <td>Year</td>
                                <td>
                                    <GetYears id="year" onLoadingChange={handleLoadingChange} />
                                </td>

                                <td>District</td>
                                <td>
                                    <GetDistricts
                                        id="dist_code"
                                        onLoadingChange={setLoadingDistricts}
                                        onChange={handleDistrictChange}
                                    />
                                </td>

                                <td>Office</td>
                                <td>
                                    {selectedDist && selectedDist !== "0" && selectedDist.toLowerCase() !== "all" ? (
                                        <GetAfsoo
                                            id="afso_code"
                                            dist_code={selectedDist}
                                            onLoadingChange={setLoadingAfso}
                                            onChange={handleAfsoChange}
                                        />
                                    ) : (
                                        <select id="afso_code" disabled>
                                            <option value="0">Select</option>
                                        </select>
                                    )}
                                </td>
                                <td>Status</td>
                                <td>
                                    <select
                                        id="statusType"
                                        value={statusType}
                                        onChange={(e) => setStatusType(e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        <option value="1">Greater Than</option>
                                        <option value="2">Greater Than Or Equal To</option>
                                        <option value="3">Less Than</option>
                                        <option value="4">Less Than Or Equal To</option>
                                        <option value="5">Equal To</option>
                                    </select>
                                </td>
                                    <td>Distribution Percentage</td>

                                <td>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        min="0"
                                        max="100"
                                        value={statusValue}
                                        onChange={handleStatusValueChange}
                                        placeholder="Enter % (0-100)"
                                    />
                                </td>

                            </tr>

                            <tr>
                                <td colSpan={12} align="center">
                                    <button
                                        onClick={handleSubmit}
                                        className="button button2"
                                        disabled={loading || loadingAfso || loadingDistricts}
                                    >
                                        Submit
                                    </button>

                                    <button className="button button2">Back</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <br />

                <div id="loading" style={{ display: "none", textAlign: "center" }}>
                    <img src="images/progress.gif" alt="Loading" />
                </div>

                <br />

                <div id="details1">{renderContent}</div>
            </div>
        </div>
    );
}

export default ShopWiseCardandSaleDetails;
